import type { TripSummary } from '../../../types/trip-summary'
import { buildTripSummary } from '../../../types/trip-summary'

const normalizeTripSummary = function (input: Object): TripSummary {
  return {
    ...buildTripSummary(),
    invoiceNumber: input.invoiceNumber,
    checkinDateTime: input.checkinDateTime ? new Date(input.checkinDateTime) : null,
    checkoutDateTime: input.checkoutDateTime ? new Date(input.checkoutDateTime) : null,
    description: input.description,
    amount: input.amount
  }
}

export {
  normalizeTripSummary
}



// WEBPACK FOOTER //
// ./src/services/b2b/normalizer/TripSummaryNormalizer.js